import React from 'react';
import ListItemRadioButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemRadioButton';
import { ReportSectionTypes } from '../redux/constants';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from '../ReportPage.scss';
const ReportSomethingElse = ({ onChange, onHide, activeTypeMap })=>{
    return /*#__PURE__*/ React.createElement("ul", {
        className: s['section']
    }, /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.Misplaced,
        label: 'This deviation is misplaced',
        subLabel: 'A deviation is in the incorrect category',
        onChange: (e)=>onChange(ReportSectionTypes.Misplaced, true)
    }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.SpamMalwareWarez,
        label: 'This is spam, malware, or warez',
        subLabel: 'A deviation that is advertising, a scam, a script bot, malware, or warez, are not allowed on DeviantArt',
        onChange: (e)=>onChange(ReportSectionTypes.SpamMalwareWarez)
    }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        disabled: !activeTypeMap[ReportSectionTypes.Abuse],
        value: ReportSectionTypes.Abuse,
        label: 'This is abuse',
        subLabel: 'Hate speech, personal attacks, or death threats',
        onChange: (e)=>onChange(ReportSectionTypes.Abuse)
    }), !activeTypeMap[ReportSectionTypes.Abuse] && /*#__PURE__*/ React.createElement("span", {
        className: s['reviewed']
    }, "This has been reviewed by staff.", ' ', /*#__PURE__*/ React.createElement("a", {
        onClick: onHide,
        className: "text-link-level-2-primary"
    }, "Hide Content?")), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        disabled: !activeTypeMap[ReportSectionTypes.SelfHarm],
        value: ReportSectionTypes.SelfHarm,
        label: 'This is self or animal harm',
        subLabel: 'Depictions of realistic violence, gore, self harm, or animal harm',
        onChange: (e)=>onChange(ReportSectionTypes.SelfHarm)
    }), !activeTypeMap[ReportSectionTypes.SelfHarm] && /*#__PURE__*/ React.createElement("span", {
        className: s['reviewed']
    }, "This has been reviewed by staff.", ' ', /*#__PURE__*/ React.createElement("a", {
        onClick: onHide,
        className: "text-link-level-2-primary"
    }, "Hide Content?")));
};
ReportSomethingElse.displayName = 'ReportSomethingElse';
export default ReportSomethingElse;

//# sourceMappingURL=ReportSomethingElse.js.map